import PageHeader from "../components/PageHeader";
import GetInTouch from "../components/Get-In-Touch";

const EnquiryNow = () => {
    return (
        <>
            <PageHeader pagetitle="Enquire Now" breadcrumbMenu="Home" breadcrumbMenuActive="Enquire Now" image="/images/enquirebanner.png"  />
            <GetInTouch />
        </>
    )
}

export default EnquiryNow;